/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { PatientAbleToWalk } from 'app/shared/model/enumerations/patient-able-to-walk.model';
import { Pain } from 'app/shared/model/enumerations/pain.model';
import { PatientCondition } from 'app/shared/model/enumerations/patient-condition.model';
import { createEntity, getEntity, reset, updateEntity } from './post-op-recovery-discharge.reducer';

export const PostOpRecoveryDischargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const postOpRecoveryDischargeEntity = useAppSelector(state => state.postOpRecoveryDischarge.entity);
  const loading = useAppSelector(state => state.postOpRecoveryDischarge.loading);
  const updating = useAppSelector(state => state.postOpRecoveryDischarge.updating);
  const updateSuccess = useAppSelector(state => state.postOpRecoveryDischarge.updateSuccess);
  const patientAbleToWalkValues = Object.keys(PatientAbleToWalk);
  const painValues = Object.keys(Pain);
  const patientConditionValues = Object.keys(PatientCondition);

  const handleClose = () => {
    navigate(`/post-op-recovery-discharge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...postOpRecoveryDischargeEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      recoveryDoctor: doctors.find(it => it.id.toString() === values.recoveryDoctor?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientAbleToWalk: 'INDEPENDENT',
          pain: 'MILD',
          conditionAtDischarge: 'STABLE',
          ...postOpRecoveryDischargeEntity,
          surgery: postOpRecoveryDischargeEntity?.surgery?.id,
          recoveryDoctor: postOpRecoveryDischargeEntity?.recoveryDoctor?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.postOpRecoveryDischarge.home.createOrEditLabel" data-cy="PostOpRecoveryDischargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.home.createOrEditLabel">
              Create or edit a PostOpRecoveryDischarge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="post-op-recovery-discharge-id"
                  label={translate('tinyMedicRestApp.postOpRecoveryDischarge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.vitalsStable')}
                id="post-op-recovery-discharge-vitalsStable"
                name="vitalsStable"
                data-cy="vitalsStable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.patientAbleToWalk')}
                id="post-op-recovery-discharge-patientAbleToWalk"
                name="patientAbleToWalk"
                data-cy="patientAbleToWalk"
                type="select"
              >
                {patientAbleToWalkValues.map(patientAbleToWalk => (
                  <option value={patientAbleToWalk} key={patientAbleToWalk}>
                    {translate(`tinyMedicRestApp.PatientAbleToWalk.${patientAbleToWalk}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.vomiting')}
                id="post-op-recovery-discharge-vomiting"
                name="vomiting"
                data-cy="vomiting"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.bleeding')}
                id="post-op-recovery-discharge-bleeding"
                name="bleeding"
                data-cy="bleeding"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.pain')}
                id="post-op-recovery-discharge-pain"
                name="pain"
                data-cy="pain"
                type="select"
              >
                {painValues.map(pain => (
                  <option value={pain} key={pain}>
                    {translate(`tinyMedicRestApp.Pain.${pain}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.conditionAtDischarge')}
                id="post-op-recovery-discharge-conditionAtDischarge"
                name="conditionAtDischarge"
                data-cy="conditionAtDischarge"
                type="select"
              >
                {patientConditionValues.map(patientCondition => (
                  <option value={patientCondition} key={patientCondition}>
                    {translate(`tinyMedicRestApp.PatientCondition.${patientCondition}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.dischargeCriteria')}
                id="post-op-recovery-discharge-dischargeCriteria"
                name="dischargeCriteria"
                data-cy="dischargeCriteria"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.active')}
                id="post-op-recovery-discharge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.cursor')}
                id="post-op-recovery-discharge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.lastupdated')}
                id="post-op-recovery-discharge-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.microSec')}
                id="post-op-recovery-discharge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.timestampentry')}
                id="post-op-recovery-discharge-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="post-op-recovery-discharge-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-recovery-discharge-recoveryDoctor"
                name="recoveryDoctor"
                data-cy="recoveryDoctor"
                label={translate('tinyMedicRestApp.postOpRecoveryDischarge.recoveryDoctor')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/post-op-recovery-discharge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PostOpRecoveryDischargeUpdate;
